import React from 'react';
import { Tabs } from 'antd';
import styled from 'styled-components';
import { ProjectStage } from '../../constants/stages';
import StageGoals from '../common/StageGoals';

const TabsContainer = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const StyledTabs = styled(Tabs)`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  
  .ant-tabs-nav {
    margin: 0;
    flex-shrink: 0;
    padding: 0 8px;
    height: 40px;
    line-height: 40px;
  }

  .ant-tabs-tab {
    padding: 8px 16px;
  }
  
  .ant-tabs-content-holder {
    flex: 1;
    overflow: hidden;
    min-height: 0;
  }
  
  .ant-tabs-content {
    height: 100%;
  }

  .ant-tabs-tabpane {
    height: 100%;
    overflow: hidden;
    padding: 0;
  }
`;

interface StageTabsProps {
  stage: ProjectStage;
  projectId?: string;
}

const StageTabs: React.FC<StageTabsProps> = ({ stage, projectId }) => {
  return (
    <TabsContainer>
      <StyledTabs
        defaultActiveKey="goals"
        items={[
          {
            key: 'goals',
            label: '阶段目标',
            children: <StageGoals stage={stage} projectId={projectId} />
          },
          // {
          //   key: 'resources',
          //   label: '个人能力清单',
          //   children: <div>个人能力清单</div>
          // },
          // {
          //   key: 'notes',
          //   label: '创业方向评估表',
          //   children: <div>创业方向评估表</div>
          // }
        ]}
      />
    </TabsContainer>
  );
};

export default StageTabs; 